import { CommercialRoles, Prisma } from "@prisma/client";

export type BulkAddCommercialsBody = {
  commercials: {
    email: string;
    commercialRole: CommercialRoles;
    jobTitle?: string | null;
  }[];
};

export type BulkAddCommercialsResult = {
  created: number;
  skipped: number;
  errors: string[];
};

export type CreateCommercialAccountBody = {
  firstName: string;
  lastName: string;
  identifier: string;
  password: string;
  commercialRole: Extract<CommercialRoles, "commercial" | "guest">;
  jobTitle: string;
};

export type UpdateCommercialAccountBody = {
  firstName?: string;
  lastName?: string;
  identifier?: string;
  password?: string;
  email?: string;
  commercialRole?: CommercialRoles;
  jobTitle?: string;
};

export type BulkCreateCommercialAccountsBody = {
  commercials: CreateCommercialAccountBody[];
};

export type BulkCreateCommercialAccountsResult = {
  created: number;
  skipped: number;
  errors: { line: number; identifier?: string; reason: string }[];
};

export const commercialsTypesValues =
  Prisma.validator<Prisma.CommercialDefaultArgs>()({
    include: {
      structure: true,
      unavailabilities: {
        orderBy: {
          date: "asc",
        },
      },
      user: {
        include: {
          picture: true,
        },
      },
    },
  });

export type CommercialType = Prisma.CommercialGetPayload<
  typeof commercialsTypesValues
>;
